import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Header, Message } from 'semantic-ui-react'
import { groupBy } from 'lodash'
import PropTypes from 'prop-types'

import { updateLocation } from '../../../actions/locationsActions'

import LocationTable from './LocationTable'

class LocationsList extends Component {
    state = { loading: false, error: '' }

    setRefClients = (appId, clientId) => {
        this.setState({ loading: true })
        var location = this.props.locations.find(l => l.app_id === appId)
        location.ref_clients = clientId
        this.props.updateLocation(location)
            .then(() => {
                this.setState({ loading: false })
            })
            .catch(err => {
                this.setState({ loading: false, error: err.message })
            })
    }

    // A section for each city
    // Table of locations details for each location
    makeLocationsInGroups = () => {
        const locationsGrouped = groupBy(this.props.locations, 'city')

        return Object.keys(locationsGrouped).map(key => (
            <div key={key} style={{ marginBottom: '40px' }}>
                <Header as="h4">{locationsGrouped[key][0].city}</Header>
                {locationsGrouped[key].map(loc => (
                    <LocationTable
                        key={loc.app_id}
                        appId={loc.app_id}
                        address={loc.address}
                        createdAt={loc.created_at.substring(0, 10)}
                        refClients={loc.ref_clients}
                        clientOpts={this.props.clientOpts}
                        onRefClientsChange={this.setRefClients}
                        loading={this.state.loading}
                    />
                ))}
            </div>
        ))
    }

    render() {
        const { locations, loadingData } = this.props
        const { error } = this.state

        if (!loadingData && locations.length === 0) {
            return <p>Mittaustietoja ei saatavilla</p>
        }

        return (
            <div>
                {loadingData ? <p>Ladataan kohteita...</p> : null}

                {this.makeLocationsInGroups()}

                {!error ? null :
                    <Message error content={error} style={{ marginBottom: '20px' }} />
                }

            </div>
        )
    }
}

const mapStoP = state => {
    var clientOpts = state.clients.data.map(client => (
        { key: client.name, value: client.id, text: client.name }
    ))
    clientOpts.unshift({ key: 'defaultOpt', value: null, text: 'Ei asiakasta' })

    return {
        loadingData: state.locationsData.loading,
        locations: state.locationsData.data,
        clientOpts: clientOpts
    }
}

const mapDtoP = dispatch => {
    return {
        updateLocation: location => dispatch(updateLocation(location))
    }
}

LocationsList.propTypes = {
    locations: PropTypes.array.isRequired,
    clientOpts: PropTypes.array.isRequired
}

export default connect(mapStoP, mapDtoP)(LocationsList)


// WEBPACK FOOTER //
// ./src/Admin/Locations/LocationsList/LocationsList.js